module.exports = __webpack_public_path__ + "media/bootstrap-icons/sunset-fill-08d2af0e.svg";